import { defineAnalytics } from '@zg-rentals/rentals-analytics';
import type { ZrmListingInfo, ZrmUserInfo } from '@zg-rentals/clickstream';
import { tracker as CLICKSTREAM } from '@zg-rentals/clickstream';

const analytics = defineAnalytics({ CLICKSTREAM });

export const trackTouringEvent = analytics.createTrackEvent<'CLICKSTREAM', ZrmUserInfo & ZrmListingInfo>('CLICKSTREAM');

export const trackTouringUserEvent = analytics.createTrackEvent<'CLICKSTREAM', ZrmUserInfo>('CLICKSTREAM');
